import { render, staticRenderFns } from "./recept-install-orders.vue?vue&type=template&id=5f276493&scoped=true"
import script from "./recept-install-orders.vue?vue&type=script&lang=js"
export * from "./recept-install-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f276493",
  null
  
)

export default component.exports